module.exports = __webpack_public_path__ + "img/c.693e19a3.jpg";